module.exports = __webpack_public_path__ + "static/media/slide3.db3905d8.png";